<template>
  <CDialog
    @click="close"
    @outer-click="close"
    @close="close"
    :show="show"
    :title="$t('plan_info')"
    :custom-class="'max-w-[421px]'"
  >
    <div class="flex p-5 flex-col justify-start text-center">
      <ul class="text-base font-normal">
        <li
          v-for="(listItem, listIndex) in plan"
          :key="listIndex"
          class="flex-y-center gap-1.5 mb-3 last:mb-0 pl-0.5"
        >
          <svg
            class="inline-flex w-6 h-6 shrink-0 fill-[#32ae60]"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm3.793 7.293L10.5 13.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l6-6a1 1 0 0 0-1.414-1.414z"
            ></path>
          </svg>
          <template v-if="listItem.type">
            <span class="text-sm font-semibold">
              <span>{{ listItem?.text }}: </span>
              <span
                class="inline-flex items-center gap-1 text-[#16cc53] font-medium"
              >
                <span>{{ listItem?.min }}</span> -
                <span class="icon-unlimited text-lg" />
              </span>
              <span class="text-xs text-[#16cc53]"> USDT</span>
            </span>
          </template>
          <template v-else>
            <span
              class="plan-info text-sm font-semibold"
              :class="{
                'text-[#2980b9] !font-normal': listItem?.type === 'bold',
              }"
              v-html="listItem.text"
            ></span>
          </template>
        </li>
      </ul>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";

interface Props {
  show: boolean;
  plan: {
    text: string;
    value?: string;
    type?: string;
  }[];
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "close"): void;
}>();

const close = () => {
  emit("close");
};
</script>

<style>
.plan-info strong {
  font-weight: 500 !important;
}
</style>
